import(/* webpackMode: "eager", webpackExports: ["Courses"] */ "/home/runner/work/all-inclusive-mono/all-inclusive-mono/apps/web/src/components/home-page/courses.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/home/runner/work/all-inclusive-mono/all-inclusive-mono/apps/web/src/components/home-page/title.tsx");
